import { Namespace, TFunction } from 'react-i18next';

import { Message } from 'api/DialogsApi';

import {
  assertFollowUpMessage,
  assertGiftMessage,
  assertIcebreakerMessage,
  assertMatchIcebreakerMessage,
  assertOfferLinkMessage,
  assertPerfectMatchMessage,
  assertPhotoMessage,
  assertStickerMessage,
  assertTextMessage,
  assertTransferLinkMessage,
  assertVideoMessage,
  assertWantsChatMessage,
} from './asserts/messages';

export const hexToBase64 = (hex: string) => {
  return (
    hex
      .match(/\w{2}/g)
      ?.map((a) => String.fromCharCode(parseInt(a, 16)))
      .join('') || ''
  );
};

export const Base64ToUtf8 = (str: string) => {
  return decodeURIComponent(escape(atob(str)));
};

export const getBlurredMessageText = (text: string) => {
  return Base64ToUtf8(hexToBase64(text));
};

export const getMessagePreview = (
  message: Message,
  t: TFunction<Namespace>
) => {
  if (message.is_failed) {
    return t('app:thread.messages.previewTypeFail');
  }

  if (
    assertTextMessage(message) ||
    assertFollowUpMessage(message) ||
    assertMatchIcebreakerMessage(message) ||
    assertIcebreakerMessage(message) ||
    assertPerfectMatchMessage(message) ||
    assertWantsChatMessage(message)
  ) {
    if (message.body_blurred) {
      return t('app:thread.messages.previewTypeBlured');
    }

    return message.body || '';
  }

  if (assertPhotoMessage(message)) {
    return t('app:thread.messages.previewTypePhoto');
  }

  if (assertVideoMessage(message)) {
    return t('app:thread.messages.previewTypeVideo');
  }

  if (assertStickerMessage(message)) {
    return t('app:thread.messages.previewTypeSticker');
  }

  if (assertGiftMessage(message)) {
    return t('app:thread.messages.previewTypeGift');
  }

  if (assertTransferLinkMessage(message) || assertOfferLinkMessage(message)) {
    const { hostname } = document.location;
    const { pathname } = new URL(message.body);

    return `${hostname}${pathname}`;
  }

  if (assertPerfectMatchMessage(message)) {
    return t('app:thread.messages.previewTypeMatch');
  }

  return t('app:thread.messages.previewTypeUnknown');
};

export const getNotificationMessagePreview = (
  message: Message,
  t: TFunction<Namespace>
) => {
  if (assertFollowUpMessage(message)) {
    return message.body_blurred
      ? getBlurredMessageText(message.body_blurred)
      : message.body || t('app:thread.messages.previewTypeUnknown');
  }

  return getMessagePreview(message, t);
};
